import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { fetechMonth } from "./gstReportDate";
export default function GstReportCard({ item }) {

  return (
    <Card
      sx={{
        width: "100%",
        m: "0px",
        mt: "10px",
        p: "0px",
        ":hover": {
          bgcolor: "#2892ba17",

        },
        // "& .MuiCardContent-root": { p: "0.5rem" }
      }}
    >
      <CardContent sx={{ padding: "0rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={6}>
            <Typography
              color="primary"
              sx={{
                fontSize: "20px",
                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 400,
                p: "0px 10px"
              }}
            >
              {fetechMonth(item?.billDate)}
            </Typography>
          </Grid>

          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CurrencyRupeeIcon color="primary" fontSize="10px" />
            <Typography
              color="primary"
              sx={{
                textOverflow: "ellipsis",
                fontSize: "20px",
                fontWeight: 400,


              }}
            >
              {item?.gst?.toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
